import React from 'react';
import Cookies from 'js-cookie';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// MUI ******************************************************************
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

//**************************************************************************/
import LogoutIcon from '../../../ui/icon/IconLogout';
import ManageAccountsIcon from '../../../ui/icon/IconSettings';
import PasswordIcon from '../../../ui/icon/IconRefresh';
// import Modals
import ChangePasswordModal from '../../../ui/modals/ChangePasswordModal';
// import APIs
import LogOutApi from '../../../api/LogOut';
// redux seters
import { RootState } from './../../../redux/reducers';
import { setAuth } from '../../../redux/reducers/user';


function TopNav(props) {
  const navigate = useNavigate();
  // redux hooks
  const { auth } = useSelector((state: RootState) => state.userAuth);
  const token = auth.token;
  const [openModal, setOpenModal] = React.useState(false);
  const dispatch = useDispatch();
  const openMenu = props.Open;
  const styleList = !openMenu
    ? { alignItems: 'center', display: 'contents' }
    : { alignItems: '', display: '' };
  // update password
  const handleOpenModal = () => setOpenModal(true);
  // logout ****************************************
  const logOut = async () => {
    const result = await LogOutApi(token);
    if (result.status === 200) {
      Cookies.remove('admin');
      dispatch(
        setAuth({
          token: null,
          userInfo: null,
          isAuthenticated: false,
        }),
      );
      navigate('/');
    }
  };
  // catch data **************************************************

  React.useEffect(() => {
  }, []);
  return (
    <>
      <List
        sx={{
          width: '100%',
          maxWidth: 360,
          bgcolor: 'background.paper',
          padding: '0px',
        }}
        component="nav"
        dir="ltr"
        aria-labelledby="nested-list-subheader"
      >
        {/* منو  **************************************************************************** */}
        <List
          style={{
            padding: '12px 28px',
            textAlign: 'center',
            backgroundColor: '#f5f5f5',
            color: '#5f5f5f',
            fontWeight: 'bold',
            textTransform: 'uppercase',
            marginBottom: '4px',
          }}
        >
          <span>{'خوش آمدید'}</span>
        </List>
        <ListItemButton>
          <Link to="/tenants" className='text-black'>
            <ListItemText primary="مدیریت مجموعه های آموزشی " />
          </Link>
          <ListItemIcon style={styleList}>
            <ManageAccountsIcon className="ms-auto" />
          </ListItemIcon>

        </ListItemButton>
        <Divider />
        <ListItemButton onClick={handleOpenModal}>
          <ListItemText primary="تغییر رمز عبور" />

          <ListItemIcon style={styleList}>
            <PasswordIcon className="ms-auto" />
          </ListItemIcon>
        </ListItemButton>
        <ListItemButton onClick={logOut}>
          <ListItemText className='text-danger' primary="خروج" />

          <ListItemIcon style={styleList}>
            <LogoutIcon className="ms-auto text-danger" />
          </ListItemIcon>
        </ListItemButton>
      </List>
      <ChangePasswordModal token={token} openModal={openModal} setOpenModal={setOpenModal} />
    </>
  );
}

export default TopNav;
